import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import {
  calculateAge,
  formatDateToThai,
} from "../../../../../utils/date.utils";
import { thaiMonths } from "../../../../../utils/monthThai";
import { numberFormat } from "../../../../../utils/common";

const Form05 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {
  const addressTypeName = "ที่อยู่ตามบัตรประจำตัวประชาชน";

  const {
    day: birth_of_day,
    month: birth_of_month,
    year: birth_of_year,
  } = formatDateToThai(dataEmployee ? dataEmployee?.date_of_birth : null);

  const {
    day: work_day,
    month: work_month,
    year: work_year,
  } = formatDateToThai(dataEmployee ? dataEmployee?.date_start_work : null);

  // console.log("dataReportDetail", dataReportDetail);
  console.log("dataEmployee", dataEmployee.address);
  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* line 1 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้า"}
          end_label={null}
          length={75}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        {/*  */}
        <RenderValue
          start_label={"ฉายา/นามสกุล"}
          end_label={null}
          length={75}
          value={
            [dataEmployee?.buddhist_name, dataEmployee?.last_name]
              .filter(Boolean)
              .join(" ") || null
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"อายุ"}
          end_label={"ปี"}
          length={20}
          value={
            dataEmployee?.date_of_birth
              ? calculateAge(dataEmployee?.date_of_birth)
              : null
          }
          isParagraph={false}
        />
      </div>
      {/* line 2 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เกีดวันที่"}
          end_label={null}
          length={20}
          value={birth_of_day}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={birth_of_month?.toString() ? thaiMonths[birth_of_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={25}
          value={birth_of_year}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"วุฒฒิการศึกษา"}
          end_label={null}
          length={90}
          value={null}
          isParagraph={false}
        />
      </div>

      {/* line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ภูมิลำเนา"}
          end_label={null}
          length={0}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <span className="ml-4">
          <RenderValue
            start_label={"บ้านเลกที่"}
            end_label={null}
            length={25}
            value={
              dataEmployee.address && dataEmployee.address.length > 0
                ? dataEmployee.address.find(
                    (address: any) =>
                      address.address_type.address_type_name === addressTypeName
                  ).house_number
                : ""
            }
            isParagraph={false}
          />
        </span>

        {/*  */}
        <RenderValue
          start_label={"หมู่ที่"}
          end_label={null}
          length={25}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).moo
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ตำบล/แขวง"}
          end_label={null}
          length={45}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).district
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"อำเภอ/เขต"}
          end_label={null}
          length={45}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).district_sub
              : ""
          }
          isParagraph={false}
        />
      </div>

      {/* line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"จังหวัด"}
          end_label={null}
          length={50}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).province
              : ""
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"รหัสไปรษณีย์"}
          end_label={null}
          length={40}
          value={
            dataEmployee.address && dataEmployee.address.length > 0
              ? dataEmployee.address.find(
                  (address: any) =>
                    address.address_type.address_type_name === addressTypeName
                ).postcode
              : ""
          }
          isParagraph={false}
        />
      </div>

      {/* line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={
            "ได้รับการบันจุแต่งตั้งเป็นบุคลากรของมหาวิทยาลัย ตามคำสั่งมหาวิทยาลัยที่"
          }
          end_label={null}
          length={50}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เมื่อวันที่"}
          end_label={null}
          length={20}
          value={work_day}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={work_month?.toString() ? thaiMonths[work_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={20}
          value={work_year}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ปัจุบันดำรงตำแหน่ง"}
          end_label={null}
          length={80}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เลขท่ี่"}
          end_label={null}
          length={35}
          value={dataEmployee?.employee_no}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ระดับ"}
          end_label={null}
          length={40}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={50}
          value={'IBSC'}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"แผนงาน"}
          end_label={null}
          length={50}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เงินเดือน"}
          end_label={"บาท"}
          length={40}
          value={
            dataReportDetail?.condition?.salary_amount
              ? numberFormat(dataReportDetail?.condition?.salary_amount, 0, 0)
              : 0
          }
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"มีความประสงค์"}
          end_label={null}
          length={220}
          value={dataReportDetail?.condition?.wish}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ณ"}
          end_label={null}
          length={140}
          value={dataReportDetail?.condition?.place}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"มีกำหนด"}
          end_label={null}
          length={20}
          value={dataReportDetail?.peroid_to_work?.year_amount}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ปี"}
          end_label={null}
          length={20}
          value={dataReportDetail?.peroid_to_work?.month_amount}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={"วัน"}
          length={20}
          value={dataReportDetail?.peroid_to_work?.day_amount}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ในกานไปเพื่อ"}
          end_label={"ครั้งนี้ ข้าพเจ้ามีความรู้ภาษาต่างปะเทศ"}
          length={125}
          value={dataReportDetail?.peroid_to_work?.reason}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"คือ"}
          end_label={null}
          length={95}
          value={dataReportDetail?.peroid_to_work?.knowledge_foreign_languages}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"โดยได้เคยเล่าเรียนจาก"}
          end_label={null}
          length={100}
          value={
            dataReportDetail?.peroid_to_work
              ?.institution_studied_foreign_languages
          }
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เป็นเวลา"}
          end_label={"ปี"}
          length={15}
          value={dataReportDetail?.peroid_to_work?.year_amount_studied}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={
            "ได้แนบสำเนาเอกสารดั่งก่าวมาด้วยแล้ว และการที่ข้าพเจ้าจะไป"
          }
          end_label={null}
          length={80}
          value={null}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ย่อมจะเป็นประโยชน์แก่ข้าพะเจ้าและมหาวิทยาลัย เพราะ"}
          end_label={null}
          length={130}
          value={dataReportDetail?.peroid_to_work?.benefits_trip}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={""}
          end_label={""}
          length={250}
          value={null}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content mt-4">
        {/*  */}
        <RenderValue
          start_label={
            "ข้าพเจ้าขอรับรองว่าจะปฎิบติตามปะกาศมหาวิทยาลัยว่าด้วยกานพฒนาบุกคลากรทุกประการ"
          }
          end_label={""}
          length={0}
          value={null}
          isParagraph={true}
        />
      </div>

      {/* signature*/}
      <div className="w-full ml-24">
        <SignaturePrint
          title={"เรียนมา/นมัสการมาด้วยความเคารพ"}
          prefix={`ลงชื่อ`}
          position={""}
          isDate={false}
          isPosition={false}
          data={{}}
        />
      </div>
      <div className="w-full">
        <CommentPrint
          title={"ความคิดเห็นของหัวหน้าส่วนงาน"}
          isCheckBoxApprove={false}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data.leave_status === "approve third" ? true : false,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={250}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{
              title: "วิทยาลัยพุทธศาสนานานาชาติ",
              date: data.created_date,
            }}
          />
        </div>

        {/* <div className="page-break"></div> */}

        <div className="">
          <div className="w-full">
            <CommentPrint
              title={"ความคิดเห็นของรองอธิการบดีฝ่ายบริหาร"}
              isCheckBoxApprove={false}
              sxTitle=""
              amountLine={2}
              isParagraph={true}
              data={{
                isApprove: data.leave_status === "approve third" ? true : false,
                comment: data.leave_approve_first_comment ?? "",
              }}
              lengthDot={250}
            />
            <div className="ml-48">
              <SignaturePrint
                title={""}
                prefix={`(ลงชื่อ)`}
                position={""}
                isDate={true}
                isPosition={true}
                data={{}}
              />
            </div>
          </div>

          <div className="w-full">
            <CommentPrint
              title={"คำสั่งของอธิการบดี"}
              isCheckBoxApprove={false}
              sxTitle=""
              amountLine={2}
              isParagraph={true}
              data={{
                isApprove: data.leave_status === "approve third" ? true : false,
                comment: data.leave_approve_first_comment ?? "",
              }}
              lengthDot={250}
            />
            <div className="ml-48">
              <SignaturePrint
                title={""}
                prefix={`(ลงชื่อ)`}
                position={""}
                isDate={true}
                isPosition={true}
                data={{}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form05;
